import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'format',
})
export class FormatPipe implements PipeTransform {
  transform(value: any) {
    value += '\n';
    return value
      .replace(/(\n)/g, '<br>')
      .replace(/\*\*\s(.*?)\<br\>?/gi, '<br><h2 class="negrito">$1</h2><br>')
      .replace(/\*\s(.*?\<br\>?)/gi, '<li class="list-style text-justify">$1</li>')
      .replace(/(.*?)\<br\>?/g, (match: any, str: string) => {
        if (str.length > 0 && !str.startsWith('<')) {
          return `<p class='text-justify'>${str}</p>`;
        }
        return match;
      })
      .replace(/\<br\>\<br\>/g, '<br>');
  }
}
